import React, { forwardRef } from "react";
import { NavLink, NavLinkProps } from "react-router-dom";

// This class is needed to forward ref when used as component in material-ui.
// This should not be required in react-router-dom v6.
// see https://github.com/ReactTraining/react-router/issues/6056
export default forwardRef<HTMLAnchorElement, NavLinkProps>((props, ref) => (
  <NavLink innerRef={ref} {...props} />
));
